import { gql } from "@apollo/client";

export const CURRENT_USER_ZENDESK_WIDGET_TOKEN = gql`
  query currentUserZendeskWidgetToken {
    currentUserZendeskWidgetToken
  }
`;

export const CURRENT_USER_FEATUREBASE_WIDGET_TOKEN = gql`
  query currentUserFeaturebaseWidgetToken {
    currentUserFeaturebaseWidgetToken
  }
`;
